import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconNotificationErrorDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" d="M12 2.502a10.2 10.2 0 0 0-7.107 3.041A9.87 9.87 0 0 0 2 12.676a9.815 9.815 0 0 0 9.833 9.824H12a10.09 10.09 0 0 0 10-10.174 9.81 9.81 0 0 0-10-9.824m-1.25 13.782A1.233 1.233 0 0 1 12 15.001a1.275 1.275 0 0 1 1.267 1.225 1.226 1.226 0 0 1-1.225 1.275 1.275 1.275 0 0 1-1.291-1.217m.417-3.333v-5a.833.833 0 1 1 1.667 0v5a.833.833 0 0 1-1.667 0" /></svg></>;
}
export default IconNotificationErrorDefault;